<template>
  <div class="px-8">
    <div
      v-for="(cause, index) in companyAdminStore.topCauses"
      :key="`cause_${index}`"
      class="flex flex-row w-full gap-8 items-center py-2 border-b border-b-gray-200"
      data-test="cause"
    >
      <div>
        <img
          :src="`https://ddb9l06w3jzip.cloudfront.net/uploadedFiles/giving_affiliate/organizations/logo/${cause.organizations_id}?thumbnail=1&amp;maxWidth=290&amp;maxHeight=164`"
          alt="organization logo"
          class="w-[48px]"
          data-test="cause-logo"
        />
      </div>
      <div
        class="flex-1 font-bold text-[14px]"
        data-test="cause-name"
      >
        {{ cause.organizationName }}
      </div>
      <div class="w-[120px]">
        <div
          class="font-medium text-[14px]"
          data-test="cause-donated"
        >
          {{ filters.formatMoney(cause.totalDonated) }} Donated
        </div>
        <div
          class="text-[14px]"
          data-test="cause-occurrences"
        >
          {{ cause.occurrences }} Donations
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import filters from '@/helpers/filters';

const companyAdminStore = useCompanyAdminStore();
</script>
